
import styled from "styled-components";

export const StyledScroll = styled.div`
position: absolute;
bottom:2%;
left:50%;
font-size:0.9rem;
transform:translateX(-50%);
cursor:pointer;

.fa-bounce{
    animation-duration: var(--fa-animation-duration, 3s);
`



